import { FaReact, FaPython } from 'react-icons/fa';
import { SiLua, SiJavascript } from 'react-icons/si';
import { IoMdCodeWorking } from 'react-icons/io';
import { MdOutlinePaid, MdOutlineVpnKey } from 'react-icons/md';
import icindproj from '../images/icindustriesproj.png';
import SafeNotes from '../images/SafeNotes.png';
import ImgRevise from '../images/ImageReviser.png';
import SatyrnVPN from '../images/SatyrnVPN.jpg';
import SimpleMenu from '../images/SimpleMenu.jpeg';

const notableProjects = [
  // {
  //   title: 'Custom CMS',
  //   image: CMSystem,
  //   description:
  //     'A web-based application to manage members within a community. This project was built for a private community to help manage their members, roles, and permissions. The backend is built with Node.js and Express, while the frontend is built with React and it uses MariaDB for the database.',
  //   link: 'https://customcms.pages.dev/',
  //   frameworks: [FaNodeJs, FaReact, SiJavascript],
  //   type: 'Paid Project',
  //   typeIcon: <MdOutlinePaid />
  // },
  {
    title: 'IC Industries',
    image: icindproj,
    description:
      'This is a website I created for a game composer and game developer studio called IC Industries. They specialize in creating unique 2D RPGs using RPG Maker.',
    link: 'https://icindustriesdev.pages.dev/',
    frameworks: [FaReact, SiJavascript],
    type: 'Paid Project',
    typeIcon: <MdOutlinePaid />
  },
  {
    title: 'SafeNotes',
    image: SafeNotes,
    description:
      'SafeNotes is a secure and easy-to-use notes application made in C# designed to keep your thoughts and information safe. With features like password verification, journaling, notepad functionalities, and dark mode, SafeNotes offers a comprehensive solution for organizing your notes securely.',
    link: 'https://github.com/Thymester/SafeNotes',
    github: 'https://github.com/Thymester/SafeNotes',
    frameworks: [SiJavascript],
    type: 'Skill Building Project',
    typeIcon: <IoMdCodeWorking />
  },
  {
    title: 'Image Revise',
    image: ImgRevise,
    description:
      'ImageRevise is a simple Tkinter-based application for resizing and optimizing images. It allows users to add watermarks, resize images while maintaining aspect ratio, and optimize them for web use. Additionally, it provides functionality to view and remove EXIF metadata from images.',
    link: 'https://github.com/Thymester/ImageRevise',
    github: 'https://github.com/Thymester/ImageRevise',
    frameworks: [FaPython],
    type: 'Skill Building Project',
    typeIcon: <IoMdCodeWorking />
  },
  {
    title: 'Satyrn VPN',
    image: SatyrnVPN,
    description:
      'A retired VPN project I had ran. This was a privacy focused VPN in partnership with Horizon.Pics',
    link: 'https://satyrnvpn.pages.dev/',
    frameworks: [FaReact, SiJavascript],
    type: 'VPN Service - Discontinued',
    typeIcon: <MdOutlineVpnKey />
  },
  {
    title: 'SimpleMenu',
    image: SimpleMenu,
    description:
      'SimpleMenu is a Menu that uses NativeUI to allow for simple tasks like Weapon Spawning, Vehicle Spawning, Ped Changing, Weapon Clearing, and Armour and Health replenishing and MORE!',
    link: 'https://github.com/Thymester/SimpleMenu',
    github: 'https://github.com/Thymester/SimpleMenu',
    frameworks: [SiLua],
    type: 'Skill Building Project',
    typeIcon: <IoMdCodeWorking />
  }
];

export default notableProjects;
